GT.MegaMenuV3 = function() {
    if(typeof isNav3 == "undefined") return;

    let linkLv1 = document.querySelectorAll('.nav-link, .global-search__toggle, .global-reach__toggle'),
        closeMegaIcons = document.querySelectorAll('.close-mega__menu'),
        htmlElm = document.firstElementChild,
        headerMenu = document.querySelector('.header-menu'), 
        closeTimerLst = [],
        isDesktop = GT.isDesktopView();

    init();
    function closeSecondary() {
        if(htmlElm.classList.contains("global-reach--opening") || GT.headerElm.querySelector(".menu-link.open") || !htmlElm.classList.contains("opening-header-overlay")) return;

        if(!htmlElm.classList.contains("opening-mobile-menu")) {
            htmlElm.classList.remove("opening-megamenu", "global-search--opening");
        }

        GT.Overlays.hideHeaderOverlay();

        closeTimerLst.push(setTimeout(() => {
            if(!htmlElm.classList.contains("global-reach--opening"))
                GT.headerElm.classList.remove("trigger-animation");
        }, 80))

        GT.headerElm.querySelectorAll(".bleed.open, .bleed .open").forEach(bleedItem => {
            bleedItem.classList.remove("open");


            bleedItem.querySelectorAll('a').forEach(item => {
                item.setAttribute('tabindex', -1);
            });

            bleedItem.querySelectorAll('.mega__level--2-group').forEach(item => {
                item.removeAttribute('tabindex');
                if(item.getAttribute('aria-expanded') == 'true'){
                    item.setAttribute('aria-expanded', 'false');
                }
            })
        })

        // megaWrapper.setAttribute("inert", true);
        linkLv1.forEach(item => {
            item.classList.remove('open');
            item.removeAttribute('tabindex');
            if (item.classList.contains('nav-link--dropdown'))
                item.setAttribute('aria-expanded', 'false');
        });


        GT.headerElm.querySelectorAll(".mega__level--2.open").forEach(lv2Item => {
            lv2Item.classList.remove("open");
        })

        GT.headerElm.style.setProperty('--bleed-height', 0);
    };

    function openSecondary(t) {
        if(htmlElm.classList.contains("global-reach--opening"))
            return;
        let panelID = t;

        htmlElm.classList.add("opening-megamenu");
        GT.Overlays.showHeaderOverlay();
        closeTimerLst.forEach(timerItem => {
            clearTimeout(timerItem);
        })

        setTimeout(() => {
            GT.headerElm.classList.add("trigger-animation");
        }, 150)

        let _extraMenu = document.querySelector('.menu-link');
        if(_extraMenu != null && _extraMenu.classList.contains('open')) {
            _extraMenu.classList.remove('open');
            _extraMenu.querySelector('button.nav-link').blur();
        }
        
        let _globalSearch = document.querySelector('.global-search');
        if(_globalSearch) {
            _globalSearch.classList.remove('open');
            _globalSearch.querySelector('input[name="q"]').blur();
        }

        let bleedItems = GT.headerElm.querySelectorAll('.bleed');

        for(let i = 0; i < bleedItems.length; i++) {
            let bleedItem = bleedItems[i];
            bleedItem.classList.remove('open');

            if(bleedItem.getAttribute('data-content') == panelID) {
                const bleedHeight = bleedItem.querySelector(".bleed-container").offsetHeight;
                activeMenuTier2 = bleedItem;
                GT.headerElm.style.setProperty('--bleed-height', (GT.wHeight < bleedHeight && isDesktop ? GT.wHeight : bleedHeight) + 'px');
                bleedItem.classList.add('open');
                // Restore the initial roles for top-level ul/li elements previously hidden from the accessibility tree using code.
                bleedItem.querySelector(".bleed-container > ul")?.removeAttribute("role");
                bleedItem.querySelectorAll(".bleed-container > ul > li").forEach(liItem => {
                    liItem.removeAttribute("role");
                });
                // megaWrapper.removeAttribute("inert");
                if(isDesktop) {
                    bleedItem.querySelectorAll('a').forEach(item => {
                        item.setAttribute('tabindex', 0);
                    })
                    // For multi-level menu item groups, hide the top-level ul/li elements from the accessibility tree,
                    // to prevent redundant screen reader announcements.
                    if(bleedItem.querySelector(".mega__level--2-group .first-level")) {
                        bleedItem.querySelector(".bleed-container > ul").setAttribute("role", "none");
                        bleedItem.querySelectorAll(".bleed-container > ul > li").forEach(liItem => {
                            liItem.setAttribute("role", "none");
                        });
                    }
                } else {
                    bleedItem.querySelectorAll('.mega__level--2-group').forEach(group => {
                        group.setAttribute('tabindex', 0);
                    })
                    bleedItem.querySelectorAll('a.mega-link--level-2, .bleed-container .group-title a.first-level').forEach(aElm => {
                        aElm.removeAttribute('tabindex');
                    })
                }
            }
        }
        
        setTimeout(function() {
            promoteArticle();
        }, 100);

    };


    function promoteArticle() {
        let _featuredMega = document.querySelector('.mega__level--3.open');
        if(!_featuredMega) return;
        let _promoteArticles = _featuredMega.querySelectorAll('.article-tile');
        [].forEach.call(_promoteArticles, function(_promoteArticle) {
            if(_promoteArticle != null) {
                let _articleHeader = _promoteArticle.querySelector('.article-tile__header');
                let _articleContents = _promoteArticle.querySelector('.article-tile__content-container');
                _promoteArticle.style.height = _articleHeader.getBoundingClientRect().height + _articleContents.getBoundingClientRect().height + 'px';
            }
        });

        setTimeout(function() {
            GT.clampArticle(true);
        }, 200);
    }

    function handleNavOpenEvents(e) {
        const target = e.target;
        const isGlobalSearchBtn = target.closest('.global-search__toggle');
        const globalSearch = document.querySelector('.global-search');
        const globalSearchInput = globalSearch.querySelector('input[name="q"');

        if(target.classList.contains("open")) {
            if(e.type == "click") {
                closeSecondary();
            }
            return;
        } else {
            closeSecondary();
        }


        if(this.classList.contains('nav-link--dropdown') && this.getAttribute('aria-expanded') == 'false') {
            if ((isGlobalSearchBtn && e.type != "click") || htmlElm.classList.contains("global-reach--opening")) return;
            this.classList.add('open');
            openSecondary(this.getAttribute('data-open'));
            this.setAttribute('aria-expanded', 'true');
            if(!isDesktop) {
                setTimeout(() => {
                    target.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
                }, 600);
            }

            if(!GT.isMobileCached) {
                linkLv1.forEach(function(item) {
                    item.setAttribute('tabindex', -1);
                });
                this.removeAttribute('tabindex');
            }
            if (isGlobalSearchBtn && globalSearchInput) {
                globalSearchInput.click();
                setTimeout(e => {
                    globalSearchInput.focus();
                }, 500);
            }
        }
    };

    
    function focusOnNavDropdown(element) {
        const currentBleed = element.closest('.bleed');
        currentBleed.querySelectorAll('.mega-link, .first-level, input, a')?.forEach(item => {
            item.setAttribute('tabindex', -1);
        })
        const currentNavLink = element.closest('.bleed').closest('li')?.querySelector('.nav-link--dropdown');
        currentNavLink?.focus();
    }

    function keypressNav(e) {
        let keycode = e.keyCode || e.which,
            _this = e.currentTarget;
        //TAB keypress
        if (keycode == 9 && !GT.isMobileCached) {
            if (_this.classList.contains('nav-link')) {
                if (e.shiftKey) {
                    e.preventDefault();
                    if (_this.getAttribute('aria-expanded') == 'true') {
                        // If mega menu is open, focus on last item in the menu
                        const dataOpen = _this.getAttribute('data-open');
                        const openBleed = document.querySelector('.bleed.open[data-content="' + dataOpen + '"]');
                        const focusItems = openBleed?.querySelectorAll('.mega-link, span.first-level, input, a');
                        
                        if (focusItems?.length) {
                            focusItems.forEach(item => {
                                item.setAttribute('tabindex', 0);
                            });
                            focusItems[focusItems.length - 1]?.focus();
                            return;
                        }
                    }
                    
                    // If no mega menu or couldn't focus on menu items, go to previous nav item
                    const previousLi = _this.closest('li').previousElementSibling;
                    if (previousLi) {
                        const previousNavLink = previousLi.querySelector('.nav-link--dropdown, .nav-link');
                        previousNavLink?.focus();
                    } else {
                        // If no previous nav item, focus on desktop logo
                        document.querySelector('header .desktop-logo')?.focus();
                    }
                } else if (_this.getAttribute('aria-expanded') == 'true') {
                    // Forward tab with mega menu open
                    e.preventDefault();
                    const dataOpen = _this.getAttribute('data-open');
                    const openBleed = document.querySelector('.bleed.open[data-content="' + dataOpen + '"]');
                    const focusItems = openBleed?.querySelectorAll('.mega-link, span.first-level, input, a');
                    
                    focusItems?.forEach(item => {
                        item.setAttribute('tabindex', 0);
                    });
                    focusItems?.[0]?.focus();
                }
            }

            const openBleed = _this.closest('.bleed.open');
            if (openBleed) {
                const allCurrentBleedLinks = openBleed.querySelectorAll('a, button, [tabindex="0"]');
                const lastLink = allCurrentBleedLinks?.[allCurrentBleedLinks.length - 1];
                // On tabbing forward (without Shift key) from the last focusable element in the mega menu, refocus on the current nav link
                if (lastLink && _this === lastLink && !e.shiftKey) {
                    e.preventDefault();
                    focusOnNavDropdown(_this);
                }
            }

            if (_this.classList.contains('global-search__toggle') && _this.getAttribute('aria-expanded') === 'true') {
                e.preventDefault();
                const globalSearch = document.querySelector('.global-search');
                const searchOverlayInput = globalSearch?.querySelector('#searchField');
                
                if (e.shiftKey) {
                    const searchResultLinks = globalSearch?.querySelectorAll('.search-overlay__contents a');
                    const lastSearchLink = searchResultLinks[searchResultLinks.length - 1];
                    (lastSearchLink || searchOverlayInput)?.focus();
                } else {
                    searchOverlayInput?.focus();
                }
            }
        }

        if (e.key === 'Escape' || e.keyCode === 27) {
            const bleedContainer = _this.closest('.bleed');
            if (bleedContainer) {
                // Find the parent nav link that opened this mega menu
                const parentNavLink = bleedContainer.getAttribute('data-content');
                const triggerNavLink = document.querySelector(`.nav-link--dropdown[data-open="${parentNavLink}"]`);
                
                // Reset all focusable items
                const focusItems = headerMenu?.querySelectorAll('.mega-link, .mega-link--level-2, .first-level, input, a');
                focusItems?.forEach(item => {
                    item.setAttribute('tabindex', -1);
                });

                // Close mega menu and focus on trigger nav link
                closeSecondary();
                triggerNavLink?.focus();
            }
        }
        
    }


    function registerEvtForOpeningSecondary() {
        for (let i = 0; i < linkLv1.length; i++) {
            let navLevel1 = linkLv1[i];
            if(!isDesktop) {
                navLevel1.removeEventListener("mouseenter", handleNavOpenEvents);
                navLevel1.removeEventListener("click", handleNavOpenEvents);
                navLevel1.addEventListener("click", handleNavOpenEvents);
            } else {
                navLevel1.removeEventListener("click", handleNavOpenEvents);
                navLevel1.removeEventListener("mouseenter", handleNavOpenEvents);
                if(!GT.isTouchDevice)
                    navLevel1.addEventListener("mouseenter", handleNavOpenEvents);
                navLevel1.addEventListener("keydown", keypressNav);
                navLevel1.addEventListener("click", handleNavOpenEvents);
            }
        }
        
        let subMenuLinks = document.querySelectorAll('.header-menu-wrapper .mega-link, .header-menu-wrapper .first-level');
        if (subMenuLinks) {
            [].forEach.call(subMenuLinks, function(item) {
                item.addEventListener('keydown', keypressNav);
            });
        }
    }

    function init() {
        GT.windowResizeFncList.desktopMegaMenuV2 = function(){
            isDesktop = GT.isDesktopView();
            closeSecondary();
            registerEvtForOpeningSecondary();
            promoteArticle();
        }

        registerEvtForOpeningSecondary();

        for(let i = 0; i < closeMegaIcons.length; i++) {
            closeMegaIcons[i].addEventListener("click", function() {
                if (document.querySelector('.nav-link.open'))
                    document.querySelector('.nav-link.open').focus();

                closeSecondary();
            });
            closeMegaIcons[i].addEventListener('keydown', keypressNav);
        }
        
        document.querySelectorAll('.mega-wrapper .article-tile').forEach(item => {
            item.addEventListener('keydown', keypressNav);
        });

        
        //Close mega nav when click outside mega menu
        if(isDesktop) {
            clickOutsideMenu();

            if(GT.headerElm)
                GT.headerElm.addEventListener("mouseleave", function(e){
                    if(isDesktop)
                        closeSecondary();
                })
        }
    }

    function clickOutsideMenu() {
        document.addEventListener('mouseup', function(e) {
            if (!GT.headerElm.contains(e.target) && !e.target.classList.contains("nav-link--dropdown") && isDesktop) {
                closeSecondary();
            }

            let langDropdownElm = document.querySelector(".header-lang");
            if (langDropdownElm && !langDropdownElm.contains(e.target)) {
                langDropdownElm.classList.remove("open")
            }
        });
    }
    return {
        closeSecondary: closeSecondary
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.MegaMenuV3 = GT.MegaMenuV3();
});
GT.MobileMenuV3 = function () {

    if(typeof isNav3 == "undefined") return;

    let toggleMenuBtns = GT.headerElm.querySelectorAll(".menu-toggle"),
        htmlElm = document.firstElementChild;
    const searchWrap = GT.headerElm.querySelector('.global-search');
    const searchInput = searchWrap?.querySelector('input[name="q"]');
    const searchOverlayModal = searchWrap.querySelector('.search-overlay__modal');
    const classOpeningMegaMenu = "opening-megamenu";
    const classOpeningMobileMenu = "opening-mobile-menu";
    const classOpeningMobileSearch = "opening-mobile-search";
    const primaryMenu = GT.headerElm.querySelector(".primary-menu");
    const primaryMenuFirstItem = primaryMenu?.querySelector('a, button');

    function activateSearchInput() {
        const newInput = document.createElement('input');
        newInput.style = 'position: absolute; top: 0; left: 0; opacity: 0; height:0;';
        searchInput.parentNode.insertBefore(newInput, searchInput.nextSibling);

        setTimeout(e => {
            searchInput.focus();
        }, 500)
        setTimeout(() => {
            newInput.remove();
        }, 1000);
    }

    function toggleRoleToPrimaryMenu(isAdding = true) {
        const primaryMenu = htmlElm.querySelector(".primary-menu");
        if(!primaryMenu) return;
        isAdding ? primaryMenu.setAttribute("role", "none") : primaryMenu.removeAttribute("role");
    }

    toggleMenuBtns.forEach(btn => {
        btn.addEventListener("click", e => {
            const currentMenuToggleBtn = e.target.closest(".menu-toggle");
            const isOpening = htmlElm.classList.contains("opening-megamenu");
            const searchToggleBtn = currentMenuToggleBtn.closest(".mobile-search-toggle");
            const onPageNav = htmlElm.querySelector(".onpage-navigation");

            // Reset expanded state on all toggle buttons
            toggleMenuBtns.forEach(btn => btn.setAttribute("aria-expanded", false));

            // Handle onpage navigation if expanded
            if (onPageNav?.classList.contains("expanded")) {
                htmlElm.classList.remove("showing-overlay");
                onPageNav.classList.remove("expanded");
            }

            // Handle search toggle
            if (searchToggleBtn) {
                handleSearchToggle(searchToggleBtn, isOpening);
            } else {
                handleMenuToggle(currentMenuToggleBtn, isOpening); 
            }

            // Handle overlay and scroll behavior
            if (!isOpening) {
                GT.lockScrollBehindOverlay(".header-menu-wrapper");
                GT.Overlays.showHeaderOverlay();
                !searchToggleBtn && initializedMegaMenuLv2();
            } else {
                GT.Overlays.hideHeaderOverlay();
                document.querySelector(".nav-level-toggle")?.click();
            }
        });
    });

    function handleSearchToggle(searchToggleBtn, isOpening) {
        if (!isOpening) {
            GT.SearchOverlayV3.triggerInitializeSearchOverlay();
            // Opening search for first time
            htmlElm.classList.add(classOpeningMegaMenu, classOpeningMobileMenu, classOpeningMobileSearch);
            toggleRoleToPrimaryMenu();
            activateSearchInput();
            GT.disableDetectScrollUpOrDown = true;
            searchToggleBtn.setAttribute("aria-expanded", true);
        } else {
            closeAllMegaMenu();
            if (htmlElm.classList.contains(classOpeningMobileSearch)) {
                // Closing search
                toggleRoleToPrimaryMenu(false);
                htmlElm.classList.remove(classOpeningMegaMenu, classOpeningMobileMenu);
                setTimeout(() => {
                    htmlElm.classList.remove(classOpeningMobileSearch);
                }, 250);
                GT.disableDetectScrollUpOrDown = false;
            } else if (htmlElm.classList.contains(classOpeningMobileMenu)) {
                GT.SearchOverlayV3.triggerInitializeSearchOverlay();
                // Switching from menu to search
                toggleRoleToPrimaryMenu();
                htmlElm.classList.add(classOpeningMobileSearch);
                searchToggleBtn.setAttribute("aria-expanded", true);
                activateSearchInput();
            }
        }
    }

    function handleMenuToggle(menuToggleBtn, isOpening) {
        toggleRoleToPrimaryMenu(false);
        if (!isOpening) {
            // Opening menu
            htmlElm.classList.add(classOpeningMegaMenu, classOpeningMobileMenu);
            GT.disableDetectScrollUpOrDown = true;
            menuToggleBtn.setAttribute("aria-expanded", true);
            primaryMenuFirstItem?.focus();
        } else {
            if (htmlElm.classList.contains(classOpeningMobileSearch)) {
                // Switching from search to menu
                htmlElm.classList.remove(classOpeningMobileSearch);
                menuToggleBtn.setAttribute("aria-expanded", true);
                primaryMenuFirstItem?.focus();
            } else {
                // Closing menu
                htmlElm.classList.remove(classOpeningMegaMenu, classOpeningMobileMenu);
                closeAllMegaMenu();
                GT.disableDetectScrollUpOrDown = false;
            }
        }
    }

    function updateBleedHeight() {
        setTimeout(() => {
            const openingBleed = GT.headerElm.querySelector(".bleed.open");
            if(openingBleed) {
                GT.headerElm.style.setProperty("--bleed-height", openingBleed.querySelector(".bleed-container").offsetHeight + "px");
            }
        }, 250)
    }

    function closeAllMegaMenu() {
        GT.headerElm.querySelectorAll(".nav-link--dropdown.open, .bleed.open, .bleed .open").forEach(item => {
            if (item.classList.contains("nav-link--dropdown")) {
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("open");
        });
        GT.headerElm.querySelectorAll(".bleed [tabindex='0']").forEach(item => {
            item.removeAttribute("tabindex");
            if(item.getAttribute('aria-expanded') == 'true'){
                item.setAttribute('aria-expanded', 'false');
            }
        });
    }

    function toggleMegaMenuLv2(e) {
        const target = e.target,
            parentElm = target.closest(".mega__level--2"),
            isOpening = parentElm.classList.contains("open");

        const oldActiveLv2 = GT.headerElm.querySelectorAll(".mega__level--2.open");
        oldActiveLv2.forEach(lv2 => {
            lv2.classList.remove("open");
        });
        
        setTimeout(() => {
            target.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
            oldActiveLv2.forEach(lv2 => {
                lv2.querySelector(".mega__level--3__listing")?.classList.remove("open");
            });
        }, 350);

        if(isOpening) { 
            target.setAttribute("aria-expanded", false); 
            updateBleedHeight(target); 
            return; 
        } else {
            target.setAttribute("aria-expanded", true);
        }

        const lv3Height = parentElm.querySelector(".mega__content--listing").offsetHeight;
        parentElm.querySelectorAll(".mega__level--3__listing a").forEach(lv3Item => {
            lv3Item.removeAttribute("tabindex");
        })
        parentElm.classList.add("open");
        parentElm.querySelector(".mega__level--3__listing")?.classList.add("open");
        parentElm.style.setProperty("--lv3-height", lv3Height + "px");
        updateBleedHeight(target);
        
        // GT.headerElm.querySelector(".header-menu-wrapper").scrollTo({top: (GT.getElementOffset(target).top) - 200, behavior: 'smooth'});
    }

    function initializedMegaMenuLv2() {
        const isDesktopView = GT.isDesktopView();
        GT.headerElm.querySelectorAll(".mega__level--2-group").forEach(item => {
            const aElm = item.querySelector("a");
            item.removeAttribute("role");
            item.removeAttribute("tabindex");
            if(aElm) {
                aElm.removeAttribute("tabindex");
                aElm.removeAttribute("aria-hidden");
                item.removeAttribute("aria-label");
                item.removeAttribute("aria-expanded");
            }
            
            if(!isDesktopView) {
                item.setAttribute("role", "button");
                if(aElm) {
                    aElm.setAttribute("tabindex", -1);
                    aElm.setAttribute("aria-hidden", "true");
                    item.setAttribute("aria-label", aElm.textContent.trim());
                    item.setAttribute("aria-expanded", false);
                }
            }

            if(!item.dataset.setEvent) {
                item.addEventListener("click", e => {
                    toggleMegaMenuLv2(e);
                })
                item.addEventListener("keydown", e => {
                    if(e.key === "Enter") {
                        toggleMegaMenuLv2(e);
                    }
                })
                item.dataset.setEvent = true;
            }
        })
    }

    GT.windowResizeFncList.mobileMenuV3 = () => {
        initializedMegaMenuLv2();
    };
};

GT.domContentLoadedFncList.push(function(){
    GT.MobileMenuV3();
});
GT.PrimaryMenuV3 = function () {
    if(typeof isNav3 == "undefined") return;

    const htmlElm = document.documentElement,
        submenuTimer = [];

    GT.triggerFnListAfterMainLogoLoaded.prepareSubMenuLink = prepareSubMenuLink;

    bindOutsideClick();
    initSearchBox();

    window.addEventListener("resize", e => {
        if(htmlElm.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();
    })
    GT.windowResizeFncList.prepareSubMenuLink = function(){
        prepareSubMenuLink(true);
    }

    function initSearchBox() {
        let globalSearch = document.querySelector('.global-search');
        let searchButton = globalSearch?.querySelector('.header-search__icon');
        let closeButton = globalSearch?.querySelector('.header-search__close');

        if(GT.isIOS()) {
            searchButton?.addEventListener('touchstart', function(e) {
                let _this = this;
                // Close humberger menu when search box is openned
                let humbergerMenu = document.querySelector('.menu-toggle');
                if(humbergerMenu.classList.contains('open')) {
                    humbergerMenu.click();
                }

                setTimeout(function() {    
                    globalSearch.classList.toggle('search-open');
                    globalSearch.closest('.main-header').classList.toggle('search-open');
                    
                    if(globalSearch.classList.contains('search-open')) {
                        GT.Overlays.showHeaderOverlay();
                    } else {
                        GT.Overlays.hideHeaderOverlay();
                    }

                    _this.addEventListener('touchend', function(e) {
                        let searchField = globalSearch.querySelector('input[name="q"]');
                        if(globalSearch.classList.contains('search-open')) {
                            searchField.setAttribute('autofocus', 'autofocus');
                            searchField.focus();
                        } else {
                            searchField.blur();
                        }
                    });
                }, 100);
            });
        } else {
            searchButton?.addEventListener('click', function(e) {
                if(GT.isMobile() || GT.isMobileView()) {
                    // Close humberger menu when search box is openned
                    let humbergerMenu = document.querySelector('.menu-toggle');
                    if(humbergerMenu.classList.contains('open')) {
                        humbergerMenu.click();
                    }

                    setTimeout(function() {
                        globalSearch.classList.toggle('search-open');
                        globalSearch.closest('.main-header').classList.toggle('search-open');
                        if(globalSearch.classList.contains('search-open')) {
                            let searchField = globalSearch.querySelector('input[name="q"]');
                            searchField.setAttribute('autofocus', 'autofocus');
                            searchField.focus();
                            GT.Overlays.showHeaderOverlay();
                        } else
                            GT.Overlays.hideHeaderOverlay();
                    }, 100);
                }
            });
        }
        
        searchButton?.addEventListener('click', function(e) {
            if(GT.isLargeDesktopView() || (!GT.isMobileView() && (e.currentTarget || e.target)?.closest(".global-search.open")))
                document.querySelector(".header-search__form")?.submit();
        })

        closeButton?.addEventListener('click', function(e) {
            if(GT.isMobile() || GT.isMobileView()) {
                if(globalSearch.classList.contains('search-open')) {
                    globalSearch.classList.remove('search-open');
                    globalSearch.closest('.main-header').classList.remove('search-open');
                    GT.Overlays.hideHeaderOverlay();
                }
            }
        })
    }

    function prepareSubMenuLink(forceRecheck) {
        let menu = document.querySelector('.main-header'),
            menuItem = menu.querySelectorAll('.level-1 > li:not(.menu-link):not(.btn-search):not(.hide-webex)'),
            appendMenuIndex = menuItem.length,
            lastMenuItem;
        
        let hasExtraItems = false,
            visibleElms = [];
        
        menu.querySelectorAll('li.menu-link').forEach(item => {
            item.remove();
        })

        if(htmlElm.classList.contains("opening-header-overlay")) 
            GT.Overlays.hideHeaderOverlay();

        GT.hideHyperLinkAnimation();
        
        menuItem.forEach(function(el){
            el.classList.remove('extra');
        })

        GT.checkElmVisible('.level-1 > li:not(.menu-link):not(.btn-search):not(.hide-webex)', e => {
            visibleElms.push(e);
            submenuTimer.forEach(timer => {
                clearTimeout(timer);
            })
            submenuTimer.push(setTimeout(() => {
                let visibleElmsLength = visibleElms.length;
                hasExtraItems = false,
                lastMenuItem = null;
                menuItem.forEach(function(el, index){
                    if (index >= visibleElmsLength) {
                        if (index == appendMenuIndex - 1 && !lastMenuItem) {
                            lastMenuItem = el;
                        }
                        el.classList.add('extra');
                        hasExtraItems = true;
                    }
                });
        
                if (hasExtraItems || forceRecheck) {
                    appendSubMenu();
                }
            }, 200));
        });

        function appendSubMenu() {
            GT.hideHyperLinkAnimation();
            let extraMenuItemsHtml = '';
            menu.querySelectorAll('li.extra').forEach(function(element){
                extraMenuItemsHtml += `<li>${element.innerHTML}</li>`;
            });

            if(lastMenuItem) {
                const extraMenuHtml = `
                    <li class="menu-link">
                        <button class="button-nav__link nav-link" aria-expanded="false" aria-label="${menu.dataset.morelabel}">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 100 100">
                                <path d="M49.5,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C54.8,47,52.4,44.6,49.5,44.6z"/>
                                <path d="M73.3,44.6c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3C78.6,47,76.2,44.6,73.3,44.6z"/>
                                <path d="M25.8,44.6c-2.9,0-5.4,2.4-5.4,5.3c0,2.9,2.4,5.3,5.4,5.3c2.9,0,5.4-2.4,5.4-5.3C31.1,47,28.7,44.6,25.8,44.6z"/>
                            </svg>
                        </button>
                        <div class="bs-hider"></div>
                        <ul class="sub-menu">${extraMenuItemsHtml}</ul>
                    </li>`;

                lastMenuItem.insertAdjacentHTML("afterend", extraMenuHtml);
            }

            document.querySelector('ul.list--mega.level-1 .menu-link')?.addEventListener('click', function(e) {
                if(htmlElm.classList.contains("global-search--opening") || htmlElm.classList.contains("global-reach--opening")) return;
                let cursorElm = this.querySelector(".button-nav__link");
                if (this.classList.contains('open')) {
                    if (e.target && !e.target.classList.contains('sub-menu'))
                        this.classList.remove('open');
                        cursorElm?.setAttribute("aria-expanded", false);
                        GT.Overlays.hideHeaderOverlay();
                } else {
                    GT.hideHyperLinkAnimation();
                    this.classList.add('open');
                    cursorElm?.setAttribute("aria-expanded", true);
                    GT.Overlays.showHeaderOverlay();
                }
            });
        }
    }

    function bindOutsideClick() {
        document.addEventListener('click', (e) => {
            const onPageNav = document.querySelector('.onpage-navigation');
            if (e.target && !e.target.closest('.onpage-navigation')) {
                if (!e.target.closest('.nav3') && !htmlElm.classList.contains("global-reach--opening")) {
                    document.querySelectorAll('ul.list--mega.level-1 .menu-link').forEach(link => link.classList.remove('open'));
        
                    // Hide header overlay if click on header, except search input
                    if (
                        e.target.id !== 'searchField' &&
                        !document.querySelector('.global-search.search-open')
                    ) {
                        GT.Overlays.hideHeaderOverlay();
                    }
                    if (onPageNav?.classList.contains('expanded')) {
                        onPageNav.classList.remove('expanded')
                    }
                }
            }
        });        
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.PrimaryMenuV3();
});
GT.Reach = function() {
    let isInited = false,
        htmlElm = document.firstElementChild,
        globalReachElm = document.querySelector(".global-reach"),
        globalReachToggleBtn = GT.headerElm.querySelector(".global-reach__toggle"),
        globalReachTabElms,
        isDesktop = GT.isDesktopView();

        
    if(typeof isNav3 == "undefined") {
        globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
    }

    function disableScroll(isDisable){
        if(isDesktop) {
            if(isDisable) {
                typeof isNav3 != "undefined" && GT.Overlays.showHeaderOverlay();
                GT.headerElm.querySelector(".menu-link.open")?.classList.remove("open");
            } else {
                GT.preventHeaderFromFlickeringWhileBodyHeightIsChanging();
                GT.headerElm.style.setProperty("--globalreach-height", 0);
                GT.headerElm.classList.remove("trigger-animation");
                setTimeout(() => {
                    typeof isNav3 != "undefined" && GT.Overlays.hideHeaderOverlay();
                }, 350);
            }
        }

        if(isDisable) {
            htmlElm.classList.add("global-reach--opening");
        } else {
            htmlElm.classList.remove("global-reach--opening");
            setTimeout(e => {
                globalReachToggleBtn?.focus();
            }, 1000)
        }
    }

    function calcActivatedTabHeight() {
        GT.headerElm.style.setProperty("--globalreach-height", (globalReachElm.querySelector(".global-reach__list.active ul")?.offsetHeight || 0) + "px");
    }

    function initReachToggle() {
        if(globalReachToggleBtn.dataset.inited)
            return;

        globalReachToggleBtn.dataset.inited = true;

        function pressESCToClose(e){
            if(e.key == "Escape") {
                globalReachToggleBtn.click();
            }
        }

        function handleElementRole() {
            if(GT.isMobileCached) {
                globalReachElm.querySelector(".global-reach__tabs").setAttribute("role", "navigation");
                globalReachElm.querySelector(".reach-region-selector").removeAttribute("role");
            }
            globalReachTabElms.forEach(tabItem => {
                const parentTab = tabItem.closest("ul");
                if(GT.isMobileCached) {
                    tabItem.setAttribute("tabindex", 0);
                    tabItem.setAttribute("aria-expanded", false);
                    tabItem.removeAttribute("role");
                    parentTab.removeAttribute("role");
                    parentTab.querySelector(".global-reach__list").removeAttribute("role");
                } else {
                    tabItem.setAttribute("role", "tab");
                    tabItem.setAttribute("aria-selected", false);
                    tabItem.removeAttribute("aria-expanded");
                    tabItem.setAttribute("tabindex", -1);
                    parentTab.setAttribute("role", "tablist");
                    parentTab.querySelector(".global-reach__list").setAttribute("role", "tabpanel");

                    if(tabItem.classList.contains("active")) {
                        tabItem.setAttribute("tabindex", 0);
                        tabItem.setAttribute("aria-selected", true);
                        setTimeout(() => {
                            TabPanelActionHandler(tabItem.closest("ul"));
                        }, 500);
                    }
                }
            })
        }

        const globalReachHeadTitle = globalReachElm.querySelector('.global-reach__head .title');

        globalReachHeadTitle?.addEventListener('keydown', keyPressHandle);

        GT.headerElm.querySelectorAll('.header-menu-mobile .nav-toggle, .global-reach .nav-level-toggle').forEach(btn => {
            btn.addEventListener('click', () => {
                if (globalReachElm.classList.contains("open")) {
                    globalReachElm.querySelectorAll('.reach-region-selector button.active, .reach-region-selector .global-reach__list.active').forEach(item => item.classList.remove('active'));
                }
            })
        })
        
        globalReachToggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // if ($(e.target).hasClass('lang-dropdown-arrow')) {
            //     e.stopPropagation();
            //     return;
            // }
            
            if(isDesktop) {
                GT.headerElm.querySelector(".header-group-btn.open")?.click();
            }

            if (globalReachElm.classList.contains("open")) {
                globalReachElm.classList.remove("open");
                globalReachToggleBtn.setAttribute("aria-expanded", false);
                globalReachElm.setAttribute("aria-hidden", true);
                disableScroll();
                window.removeEventListener("keydown", pressESCToClose);
            } else {
                window.addEventListener("keydown", pressESCToClose);
                globalReachElm.classList.add("open");
                globalReachElm.removeAttribute("aria-hidden");
                globalReachToggleBtn.setAttribute("aria-expanded", true);


                if(!isInited) {
                    GT.headerElm.classList.add("fetching");
                    isInited = true;
                    
                    globalReachElm.querySelectorAll('.global-reach__close, .nav-level-toggle').forEach(closeElm => {
                        closeElm.addEventListener("click", () => {
                            globalReachElm.classList.remove("open");
                            globalReachElm.setAttribute("aria-hidden", true);
                            globalReachToggleBtn.setAttribute("aria-expanded", false);
                            disableScroll();
                        })
                    });


                    httpService = new HttpService();
                    httpService.getHtmlContent(globalReachLink, null, {"Content-type": "application/x-www-form-urlencoded"}, true).then(response => {

                        let globalReachRegionsMoileLV1Elm = document.querySelector(".mobile__global--level-1 .list");
                        if(globalReachRegionsMoileLV1Elm)
                            globalReachRegionsMoileLV1Elm.classList.remove("hide");

                        globalReachElm.querySelector("#global-reach-regions").insertAdjacentHTML("beforeend", `
                            <div class="translate-animation-item slow">
                                <div class="global-reach__content">
                                    ${response}
                                </div>
                            </div>
                        `);
                        GT.hideHyperLinkAnimation();
                        calcActivatedTabHeight();
                        setTimeout(function() {
                            GT.headerElm.classList.add("trigger-animation");
                            globalReachTabElms = document.querySelectorAll('.reach-region-selector li button');
                            
                            globalReachTabElms.forEach(tabItem => {
                                tabItem.addEventListener("click", keyPressHandle);
                                tabItem.addEventListener("keydown", keyPressHandle);
                            })

                            if(isDesktop)
                                globalReachTabElms[0].click();
                            
                            handleElementRole();
                            GT.GTMGlobal.megaMenu();
                        }, 100);
                    })
                    .catch((rej) => {
                        isInited = false;
                    })
                    .finally(() => {
                        GT.headerElm.classList.remove("fetching");
                    });

                } else {
                    GT.headerElm.classList.add("trigger-animation");
                    calcActivatedTabHeight();
                    
                    handleElementRole();
                }

                disableScroll(true);
                setTimeout(function() {
                    globalReachElm.querySelector(".global-reach__head a")?.focus();
                    linkHandle();
                }, 1000);
            }
        });

    }

    function keyPressHandle(e) {
        if (e.key != "Tab") {
            e.preventDefault();
        }

        if (e.key == "Tab") {
            if (isDesktop) {
                const target = e.target;
                const activeLinks = globalReachElm.querySelectorAll('.global-reach__list.active .local-site-link');
                const firstActiveLink = activeLinks[0];
                const lastActiveLink = activeLinks[activeLinks.length - 1];

                if (e.shiftKey) {
                    if (target.closest('.global-reach__head')) {
                        e.preventDefault();
                        lastActiveLink && lastActiveLink.focus();
                    }
                } else {
                    if (target.getAttribute('aria-selected') == "false") {
                        e.preventDefault();
                        firstActiveLink && firstActiveLink.focus();
                    }
                }
            }
        }

        if (!e.keyCode || e.key == "Enter" || e.key == " ") {
            GT.hideHyperLinkAnimation();
            const currentTab = e.target,
                activeEl = currentTab.dataset.tab;

            if (!currentTab.classList.contains("active")) {
                globalReachTabElms.forEach(tabItem => {
                    tabItem.setAttribute("aria-selected", false);
                })

                if(!GT.isMobileCached) {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.removeAttribute("aria-expanded");
                        tabItem.setAttribute("tabindex", -1);
                    })
                    currentTab.setAttribute("tabindex", 0);
                    currentTab.setAttribute("aria-selected", true);
                } else {
                    globalReachTabElms.forEach(tabItem => {
                        tabItem.setAttribute("aria-expanded", false);
                    })
                    currentTab.setAttribute("aria-expanded", true);
                }

                globalReachTabElms.forEach(tabItem => {
                    tabItem.classList.remove("active");
                })
                currentTab.classList.add("active");

                document.querySelectorAll(".global-reach .global-reach__list").forEach(listPanelItem => {
                    listPanelItem.classList.remove("active");
                    listPanelItem.querySelectorAll('a')?.forEach(item => {
                        item.setAttribute('tabindex', -1);
                    })
                    
                    if (listPanelItem.classList.contains(activeEl)) {
                        listPanelItem.classList.add("active");
                        listPanelItem.querySelectorAll('a')?.forEach(item => {
                            item.setAttribute('tabindex', 0);
                        })
                        calcActivatedTabHeight();
                    }
                })

                if(!isDesktop)
                    setTimeout(() => {
                        currentTab.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
                    }, 400);
            } else {
                if(!isDesktop) {
                    currentTab.classList.remove("active");
                    document.querySelector(".global-reach .global-reach__list.active")?.classList.remove("active");
                    GT.headerElm.style.setProperty("--globalreach-height", 0);
                    currentTab.setAttribute("aria-expanded", false);
                }
            }
        }
    }

    function linkHandle() {
        document.querySelectorAll('.global-reach__list a').forEach(item => {
            let parentElm = item.closest('li');
            item.addEventListener('keydown', function(e) {
                if (e.key == 'Tab' && !e.shiftKey && !parentElm.nextElementSibling && isDesktop) {
                    e.preventDefault();
                    document.querySelector('.global-reach__head .title').focus();
                }
            });
        });
    }

    initReachToggle();
    
    GT.windowResizeFncList.globalReach = function(){
        isDesktop = GT.isDesktopView();
        if(htmlElm.classList.contains("global-reach--opening"))
            globalReachToggleBtn.click();

        if(typeof isNav3 == "undefined") {
            globalReachToggleBtn = GT.isMobileView() ? GT.headerElm.querySelector(".global-toggle-m") : GT.headerElm.querySelector(".global-reach__toggle");
        }
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.Reach();
})
GT.SearchOverlayV3 = function() {
    let htmlElm = document.firstElementChild;
    let searchWrapper = document.querySelector('.btn-search');
    let searchButtonToggle = searchWrapper?.querySelector('.global-search__toggle');
    let globalSearch = document.querySelector('.global-search');
    let searchForm = globalSearch.querySelector('.header-search__form');
    let searchOverlayModal = globalSearch.querySelector('.search-overlay__modal');
    let searchboxInput = searchForm.querySelector('input[name="q"]');
    let searchButton = globalSearch.querySelector('.header-search__icon');
    let submitButton = globalSearch.querySelector('form.header-search__form input[name="search-submit__button"]');
    let popularSearchResults = null;
    let prevSuggestionResults = null;
    let searchResultsContainer = globalSearch.querySelector('.search-overlay__contents');
    let disabledSearchOverlayAtrr = searchboxInput.getAttribute('disabled-searchoverlay');
    let disabledPopularSearchAtrr = searchboxInput.getAttribute('disabled-popularsearch');
    let disabledPreviousSearchAtrr = searchboxInput.getAttribute('disable-previoussearch');
    let userPreviousSearchesDataAtrr = null;
    let oldSearchKeyword = "";
    let isInitialized = false;
    const bleedWrapperElm = document.querySelector('.btn-search .bleed-wrapper');

    const INPUT_START_TYPING_LENGTH = 3;
    const MAX_PREVIOUS_SEARCH_ITEMS = 6;
    let httpService = new HttpService();

    init();

    function processPreviousSearch() {

        if(isDisabledPreviousSearch()) return;

        let searchPageUrl = searchForm.getAttribute('action');
        let previousSearchTitle = searchOverlayModal.getAttribute('previous-search-title');
        let userPreviousSearches = JSON.parse(localStorage.getItem('user_previous_searches'));
        // Show previous search section
        if(userPreviousSearches != null && userPreviousSearches.length > 0) {
            userPreviousSearchesDataAtrr = userPreviousSearches;
            let previousSearchHtml = '<div class="popular-search__container">';
            previousSearchHtml     += '    <div class="gt-small-title heavy search-panel__title">' + previousSearchTitle +'</div>';
            previousSearchHtml     += '    <div class="search-panel__details">';
            previousSearchHtml     += '        <ul class="search-suggestion__list">';
            
            [].forEach.call(userPreviousSearches, function(_keyword) {
                previousSearchHtml += '<li><a href="' + searchPageUrl + '?q=' + encodeURIComponent(_keyword) + '" title="' + _keyword + '">' + _keyword.replace(/(<([^>]+)>)/gi, "") + '</a></li>';
            });

            previousSearchHtml     += '        </ul>';
            previousSearchHtml     += '    </div>';
            previousSearchHtml     += '</div>';
            
            let previousSearchesSection = document.getElementById('previous-search__container');
            if(previousSearchesSection != null) {
                previousSearchesSection.remove();
            }

            let wrapPreviousSearchesHtml = document.createElement('div');
            wrapPreviousSearchesHtml.id = 'previous-search__container';
            wrapPreviousSearchesHtml.className = 'search-contents__container';

            wrapPreviousSearchesHtml.innerHTML = previousSearchHtml;
            searchResultsContainer.insertBefore(wrapPreviousSearchesHtml, searchResultsContainer.firstChild);
        }
    }

    function triggerInitializeSearchOverlay() {
        openGlobalSearch();

        toggleSearchModal(false);
        
        // Process to display user's previous searches

        if(!isInitialized) {
            processPreviousSearch();

            // Show modal in case second time user focus to search box when input length > 3
            let _searchKeyword = this.value?.trim() || "";
            if(_searchKeyword.length >= INPUT_START_TYPING_LENGTH) {
                // Send ajax request if only input new keyword 
                if(_searchKeyword != oldSearchKeyword.trim()) {
                    oldSearchKeyword = _searchKeyword;
                    getSuggestionSearch(encodeURIComponent(_searchKeyword));
                } else {
                    if(prevSuggestionResults) {
                        searchResultsContainer.innerHTML = prevSuggestionResults;
                    }
                    openGlobalSearch();
                    toggleSearchModal(true);
                }
            } else {
                if((popularSearchResults != null && popularSearchResults.length > 0)
                    || (userPreviousSearchesDataAtrr != null && userPreviousSearchesDataAtrr.length > 0)
                ) {
                    toggleSearchModal(true);
                }
            }
            isInitialized = true;
        }

        if(isDisabledPopularSearch()) {
            // Hide search overlay modal in case input length < 3
            if((searchboxInput.value.length < INPUT_START_TYPING_LENGTH) 
                && (userPreviousSearchesDataAtrr == null || userPreviousSearchesDataAtrr.length <= 0)) {

                toggleSearchModal(false);
            }

            return;
        }

        // Show popular search on modal when first time user focus to search box
        if(popularSearchResults == null || popularSearchResults.length <= 0) {
            getPopularSearch();
        }
        searchResultsContainer.classList.add('show');
        toggleLoading(false);
        GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
    }

    function initSearchOverlay() {
        searchboxInput.addEventListener('click', function() {
            triggerInitializeSearchOverlay();
        });

    };

    function isDisabledPreviousSearch() {
        return (!disabledPreviousSearchAtrr || disabledPreviousSearchAtrr.toLowerCase() == 'true');
    }

    function isDisabledPopularSearch() {
        return (!disabledPopularSearchAtrr || disabledPopularSearchAtrr.toLowerCase() == 'true');
    }

    function openGlobalSearch() {
        if(document.querySelector('.global-reach.open')) return;

        if(!globalSearch.classList.contains('open')) {
            globalSearch.querySelectorAll('input, a, button').forEach(item => {
                item.removeAttribute('tabindex');
            })
            globalSearch.classList.add('open');
        }

        if (GT.isDesktopView())
            htmlElm.classList.add("global-search--opening");
    }

    function toggleSearchModal(_isShow) {
        if(_isShow) {
            setTimeout(e => {
                GT.GTMGlobal.globalSearch();
            }, 100);
        }
    }

    function toggleLoading(enable) {
        const header = document.querySelector('.header');
        if (enable) {
            header.classList.add('fetching');
        } else
            header.classList.remove('fetching');
    }

    function escapeQueryChars(url) {
        return url
            .replace(/\s/gi, '+')
            .replace(/\%20/gi, '+')
            .replace(/\%(3C|3E)/gi, function (match, dec) {
                return encodeURI('%') + dec;
            });
    }

    function getPopularSearch() {
        let popularSearchEndpoint = searchboxInput.getAttribute('data-endpoint-popularsearch');
        if(popularSearchEndpoint == null || popularSearchEndpoint.length <= 0) return;
        popularSearchEndpoint = escapeQueryChars(popularSearchEndpoint);

        let recentIds = GT.Cookies.getCookie("recentIds");
        popularSearchEndpoint += "&recentIds=" + recentIds;
        
        httpService.getHtmlContent(popularSearchEndpoint, null, { "Content-type": "application/x-www-form-urlencoded" }, true).then(data => {
            if (data.trim() == null || data.trim().length <= 0) {
                if (!userPreviousSearchesDataAtrr) {
                    toggleSearchModal(false);
                } else {
                    toggleSearchModal(true);
                }
            } else {
                popularSearchResults = data;
                searchResultsContainer.innerHTML = data;
                processPreviousSearch();
                linkKeyPressHandle();
                toggleSearchModal(true);
            }

            
        })
            .catch((rej) => {
                console.log(rej)
            })
            .finally(() => {
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
            });

    }

    function getSuggestionSearch(_searchTerm) {
        let suggestionSearchEndpoint = searchboxInput.getAttribute('data-endpoint-searchsuggestion');

        if(suggestionSearchEndpoint == null || suggestionSearchEndpoint.length <= 0) return;

        suggestionSearchEndpoint = suggestionSearchEndpoint + _searchTerm;

        suggestionSearchEndpoint = escapeQueryChars(suggestionSearchEndpoint);
        
        httpService.getHtmlContent(suggestionSearchEndpoint, null, { "Content-type": "application/x-www-form-urlencoded" }, true).then(data => {
                if(data.trim() == null || data.trim().length <= 0) {
                    toggleSearchModal(false);
                } else {
                    prevSuggestionResults = data;
                    searchResultsContainer.innerHTML = data;
                    openGlobalSearch();
                    linkKeyPressHandle();
                    toggleSearchModal(true);
                }
            })
            .catch((rej) => {
                console.log(rej)
            })
            .finally(() => {
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
                toggleLoading(false);
            });
    }

    function linkKeyPressHandle() {
        const CONTAINER_SELECTORS = [
            '.recently-visited__container',
            '.search-contents__container.popular-search__container',
            '.results-search__container.has-search__results',
            '.popular-search__container.results-search__container'
        ];
        
        const searchOverlayLinks = document.querySelectorAll('.search-suggestion__list a, .search-results__list a');

        searchOverlayLinks.forEach(item => {
            // Only process last links in their list
            if (item.closest('li').nextElementSibling) return;

            // Find the parent container
            let parentContainer = item.closest('#previous-search__container');
            if (!parentContainer) {
                parentContainer = CONTAINER_SELECTORS
                    .map(selector => item.closest(selector))
                    .find(element => element !== null);
            }

            // Add tab handler for last link in last container
            if (parentContainer && !parentContainer.nextElementSibling) {
                item.addEventListener('keydown', (e) => {
                    if ((e.key === 'Tab' || e.keyCode === 9) && !e.shiftKey && GT.isDesktopView()) {
                        e.preventDefault();
                        searchButtonToggle?.focus();
                    }
                });
            }
        });
    }

    function init() {
        if(!disabledSearchOverlayAtrr || disabledSearchOverlayAtrr.toLowerCase() == 'true') {
            return;
        }

        initSearchOverlay();

        globalSearch.addEventListener("keydown", (e) => {
            const { key, target } = e;

            if (key === "Tab" && GT.isDesktopView()) {
                if (target === searchboxInput || target === searchButton) {
                    e.preventDefault();
                    
                    if (target === searchboxInput) {
                        e.shiftKey ? searchButtonToggle?.focus() : searchButton.focus();
                    } else {
                        if (e.shiftKey) {
                            searchboxInput.focus();
                        } else {
                            const firstLink = globalSearch.querySelector('.search-overlay__contents a');
                            (firstLink || searchButtonToggle)?.focus();
                        }
                    }
                }
            }

            if (key === "Escape" && document.querySelector('.global-search.open')) {
                GT.isScreenReader = true;
                closeAction();
            }
        });

        searchboxInput.addEventListener('input', GT.debounce(function(){
            searchboxOnChange();
        }, 500));

        searchButton.addEventListener('click', function(e) {
            if(searchboxInput.value.length <= 0) {
                searchboxInput.focus();
                return;
            }
            submitButton.click();
        });



        function handleFirstFocusableElm() {
            let _firstFocusable = GT.getFirstFocusableVisible();

            if(!_firstFocusable.dataset.initialized)
                _firstFocusable.addEventListener('keydown', function(e) {
                    let _keycode = e.keyCode || e.which;
                    if (9 == _keycode && e.shiftKey) {
                        e.preventDefault();
                        document.querySelector('#searchField').focus();
                    }
                });

            _firstFocusable.dataset.initialized = true;
            // #175120 - Remove focusing on first element when user close the Global search when scrolling the page
            if(window.scrollY < 10)
                setTimeout(function() {
                    _firstFocusable.focus();
                },500);
        }

        function closeAction(){
            closeSearchOverlay();
            // handleFirstFocusableElm();
        }


        searchForm.addEventListener('submit', e => {

            if(isDisabledPreviousSearch()) return;

            let searchkeyword = searchboxInput.value;
            
            if(searchkeyword == null || searchkeyword.trim().length <= 0) {
                return false;
            }
                            
            //Process to save search keyword into local stograde before submit search form
            GT.processSearchKeywordBeforeSubmit(searchkeyword.trim(), userPreviousSearchesDataAtrr, MAX_PREVIOUS_SEARCH_ITEMS);
            dataLayer.push({ 'event': 'global_search', 'eventAction': 'navigation_search', 'eventLabel': searchkeyword });
        });
    }

    function searchboxOnChange(){
        let inputValue = searchboxInput.value.trim();
        if(inputValue.length >= INPUT_START_TYPING_LENGTH) {
            toggleLoading(true);
            getSuggestionSearch(encodeURIComponent(inputValue));
            oldSearchKeyword = inputValue;
        } else {
            if((isDisabledPopularSearch() || popularSearchResults == null) && (userPreviousSearchesDataAtrr == null || userPreviousSearchesDataAtrr.length <= 0)) {
                toggleSearchModal(false);
            } else {
                searchResultsContainer.innerHTML = popularSearchResults;
                
                // Add previous search section
                processPreviousSearch();
                GT.headerElm.style.setProperty('--bleed-height', bleedWrapperElm.offsetHeight + 'px');
                toggleSearchModal(true);
            }
        }
    }

    function closeSearchOverlay() {
        globalSearch.classList.remove('open');
        globalSearch.querySelectorAll('input, a, button').forEach(item => {
            item.setAttribute('tabindex', -1);
        })

        if (GT.isDesktopView()) {
            GT.MegaMenuV3.closeSecondary();
            setTimeout(() => {
                searchButtonToggle.focus();
            });
        }
    }

    return {
        triggerInitializeSearchOverlay
    }
};

GT.domContentLoadedFncList.push(function(){
    GT.SearchOverlayV3 = GT.SearchOverlayV3();
});

GT.TopBannerMessageForNoStickyHeader = function($elem) {
    var isStickyDisabled = !$('header').data('sticky');
    var header = $elem[0];

    $(document).ready(function() {
        if (isStickyDisabled) {
            window.onscroll = function() { handleTopBannderMessageOnMobile(); };
            window.onwheel = function() { handleTopBannderMessageOnMobile(); };
            window.onresize = function() { handleTopBannderMessageOnMobile(); };
            handleTopBannderMessageOnMobile();
        }
    });
    function isMessageTopBannerExist() {
        return $(header).find('.header-message-top-banner-wrapper').length;
    }
    function handleTopBannderMessageOnMobile() {
        if(isMessageTopBannerExist()) {
            if($(window).width() < 961){
                // if (window.pageYOffset > 0) {
                //     // $(header).find('.header-top').css('top', '0');
                //     $('.mobile').css('top', '63px');
                //     // $(header).find('.header-message-top-banner-wrapper').addClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', '');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', '64px');
                //     // }
                // } else if ($('html').css('position') != 'fixed') {
                //     var topBannerMessageHeight = $(header).find('.header-message-top-banner-wrapper').height();
                //     // $(header).find('.header-top').css('top', topBannerMessageHeight +'px');
                //     $('.mobile').css('top', topBannerMessageHeight+63 +'px');
                //     // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                //     //recalculate header's height
                //     // if($(header).hasClass('campaign-header')) {
                //     //     $(header).css('height', (topBannerMessageHeight) + 'px');
                //     // } else if ($(header).hasClass('main-header')){
                //     //     $(header).css('height', (topBannerMessageHeight+64) + 'px');
                //     // }
                // }
            } else {
                // reset when resize to desktop 
                // $(header).find('.header-message-top-banner-wrapper').removeClass('hidden-message');
                // $(header).find('.header-top').css('top', '0');
                // $(header).css('height', '');
                $('.insight-page').find('.breadcrumbs').css('padding-top', '30px');                
            }
        }
    }
}


GT.UtilityNavigation = function (elem) {
    let me = this;
    me.init = function () {

        function pressESCToClose(e){
            if(e.key == "Escape") {
                langDropdown.btnToggle.focus();
                langDropdown.btnToggle.click();
            }

            if(e.key == "Tab" && e.shiftKey && (e.target || e.currentTarget).classList.contains("header-lang__select")) {
                if(langDropdown.itemsLength) {
                    e.preventDefault();
                    langDropdown.items[langDropdown.itemsLength - 1].focus();
                }
            }
        }


        let langDropdown = {
            btnToggle: document.querySelector('.header-lang__select'),
            items: document.querySelectorAll('.header-lang__dropdown a'),
            doToggle: function() {
                let headerLangBtn = document.querySelector('.header-lang');
                
                headerLangBtn.classList.toggle('open');
                if ( headerLangBtn.classList.contains('open') ) {
                    GT.hideHyperLinkAnimation();
                    this.btnToggle.setAttribute('aria-expanded', 'true');
                    window.addEventListener("keydown", pressESCToClose);
                } else {
                    this.btnToggle.setAttribute('aria-expanded', 'false');
                    window.removeEventListener("keydown", pressESCToClose);
                }
            }
        };

        if(langDropdown.btnToggle) {
            langDropdown.itemsLength = langDropdown.items.length;
            langDropdown.btnToggle.addEventListener('click', function() { 
                langDropdown.doToggle(); 
            });

            if(langDropdown.itemsLength) {
                langDropdown.items[langDropdown.itemsLength - 1].addEventListener("keydown", e => {
                    if(e.key == "Tab" && !e.shiftKey) {
                        e.preventDefault();
                        langDropdown.btnToggle.focus();
                    }
                })
            }
        }
    }
    me.init();
};
GT.isNav2 = true;

GT.Initiator = function (__object) {
    // if test passed (selector present on site) - fire function form current object on obj context (passing as argument selector and arguments or empty)
    var __$tmp = __object.settings && __object.settings.nojquery ? document.querySelectorAll(__object.test) : $(__object.test);
    try {
        if (__$tmp.length && __object.constr)
            new __object.constr(__$tmp, __object);
    } catch (exp) {
        console.warn(exp);
    }
};

GT.domContentLoadedFncList.push(function(){

    GT.Cookies = new GTCookies();
    GT.Cookies.cookieNotify();

    GT.GTObjects = [
        { constr: GT.StickyHeaderV2, test: '.main-header', settings: { }},
        { constr: GT.PrimaryNavV2, test: '.header-menu', settings: { } },
        { constr: GT.FakeHyperlink, test: '[data-anchor]' },
        { constr: GT.SearchOverlayV2, test: '.global-search' },
        { constr: GT.MegaNavigationV2, test: '.mega-wrapper', settings: { } },
        { constr: GT.MobileNavigationV2, test: '.menu-toggle', settings: { } },
        { constr: GT.UtilityNavigation, test: '.header-utils', settings: { } }
    ];

    if(typeof isV1GT == "undefined") 
        GT.GTObjects.push({ constr: GT.Reach, test: '.global-reach' });

    GT.GTObjects.map(GT.Initiator);
});
GT.freezeVp = function (e) {
    e.preventDefault();
};


window.addEventListener("DOMContentLoaded", function(){
    GT.headerElm = document.querySelector("header");
    if(GT.headerElm)
        GT.topBannerMsgElm = document.querySelector(".header-message-top-banner-wrapper");
    
    GT.mainHeaderElm = document.querySelector(".main-header");
    GT.wHeight = window.innerHeight;
    GT.wWidth = window.innerWidth;
    GT.bodyWidth = document.body.clientWidth;
    GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
    document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');

    if(typeof isV1GT == "undefined") {
        GT.isTouchDevice = GT.isTouchDevice();
        GT.domContentLoadedFncList.forEach(function(fnc){
            try {
                fnc();
            } catch (e) {
                console.log(e);
            }
        })
    }

	initTabPanelActionHandler();

    function triggerFunctionsAfterMainLogoLoaded(){
        setTimeout(function() {
            Object.keys(GT.triggerFnListAfterMainLogoLoaded).forEach(function(k) {
                GT.triggerFnListAfterMainLogoLoaded[k]();
            })
            setTimeout(function(){
                if(GT.headerElm) {
                    GT.headerElmHeight = GT.headerElm.clientHeight;
                    document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
                }

                if(GT.scrollTop() < 100 && !location.hash)
                    window.scrollTo(0,0);
            }, 50)
        })
    }

    let desktopLogo = document.querySelector(".desktop-logo img");
    if(desktopLogo) {
        desktopLogo.onload = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        desktopLogo.onerror = function(){
            triggerFunctionsAfterMainLogoLoaded();
        }
        if(desktopLogo.complete) {
            triggerFunctionsAfterMainLogoLoaded();
        }
    } else
        triggerFunctionsAfterMainLogoLoaded();

    if(GT.topBannerMsgElm) {
        document.documentElement.style.setProperty('--top-banner-msg-height', GT.topBannerMsgElm.clientHeight + 'px');
    }

    if(GT.mainHeaderElm) {
        GT.mainHeaderElmHeight = GT.mainHeaderElm.clientHeight;
        document.documentElement.style.setProperty('--main-header-height', GT.mainHeaderElmHeight + 'px');
    }
});

let isOrientationChange = false;
if(window.screen.orientation)
    window.screen.orientation.addEventListener('change', function(){
        isOrientationChange = true;
    });
else
    window.addEventListener("orientationchange", function() {
        isOrientationChange = true;
    });

GT.recalculateHeaderHeight = function(){
    setTimeout(function(){
        if(GT.headerElm) {
			GT.stickyHeaderOffsetTop = GT.headerElm.firstElementChild.offsetHeight - (GT.isMobileView() ? 64 : 88);
            GT.headerElmHeight = GT.headerElm.clientHeight;
            document.documentElement.style.setProperty('--header-height', GT.headerElmHeight + 'px');
        }

        if(GT.topBannerMsgElm) {
            GT.topBannerMsgElmHeight = GT.topBannerMsgElm.clientHeight;
            document.documentElement.style.setProperty('--top-banner-msg-height', GT.topBannerMsgElmHeight + 'px');
        }

        if(GT.mainHeaderElm) {
            GT.mainHeaderElmHeight = GT.mainHeaderElm.clientHeight;
            document.documentElement.style.setProperty('--main-header-height', GT.mainHeaderElmHeight + 'px');
        }
    }, 500)
}

window.addEventListener("resize", function(){
    GT.wHeight = window.innerHeight;
    GT.wWidth = window.innerWidth;
    GT.bodyWidth = document.body.clientWidth;
    GT.scrollbarWidth = GT.wWidth - GT.bodyWidth;
    document.documentElement.style.setProperty('--scrollbar-width', GT.scrollbarWidth + 'px');
    document.documentElement.style.setProperty('--window-height', GT.wHeight + 'px');
    GT.recalculateHeaderHeight();
    
    GT.isMobileCached = GT.isMobile();
});

window.addEventListener("resize", GT.debounce(function(){
    //resize event always fires in Mobile browser if scrolling, because of browser's menu bar
    if(!GT.isMobileCached || isOrientationChange) {
        GT.hideHyperLinkAnimation();
        Object.keys(GT.windowResizeFncList).forEach(function(k) {
            if(typeof GT.windowResizeFncList[k] == "function")
                GT.windowResizeFncList[k]();
        })
        GT.recalculateHeaderHeight();
    }
    isOrientationChange = false;
}, 250));

document.addEventListener('touchmove', function(e){
    Object.keys(GT.touchMoveFncList).forEach(function(k) {
        GT.touchMoveFncList[k](e);
    })
}, {passive: false});